var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC1VenetianBlindUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 7v62h50V7H13zm16 17v-3h18v3H29zm0-8v-3h18v3H29zm-12-3h8v3h-8v-3zm0 8h8v3h-8v-3zm19 44H17V30h19v35zm23 0H40V30h19v35zm0-41h-8v-3h8v3zm0-8h-8v-3h8v3z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C1_Venetian_blind_up.ac2b1c53.svg";
export { SvgC1VenetianBlindUp as ReactComponent };